import Rails from '@rails/ujs';
import debounce from "../../utils/debounce";

export default class StudentsIndex {

    constructor() {
        this.debouncedSubmit = null;
        this.bindEvents();
    }

    bindEvents() {
    const $searchInput = $("#student-search-bar");
        const $form = $("#student-search-form");

        $form.on("ajax:success", (event) => {
            const [_data, _status, xhr] = event.detail;
            this.displayResults(xhr.responseText);
        });

        $form.on("ajax:error", (event) => {
            this.displayError();
        });

    // Live search while typing (reusable debounce)
        this.debouncedSubmit = debounce((e) => {
            const query = e.target.value.trim();
            const formElement = $form.get(0);

            if (query.length >= 2) {
                Rails.fire(formElement, 'submit');
            } else {
                this.hideDropdown();
            }
        }, 300);

        $searchInput.on("input", this.debouncedSubmit);

    // Close the dropdown when clicking outside
        $(document).on("click", (e) => {
            if (!$(e.target).closest("#student-search-bar-container").length) {
                this.hideDropdown();
            }
        });

    // Clear the search with Escape
        $searchInput.on("keydown", (e) => {
            if (e.key === "Escape") {
                $searchInput.val('');
                this.hideDropdown();
            }
        });
    }

    // Cleanup for when the controller is destroyed / unloaded
    destroy() {
        const $searchInput = $("#student-search-bar");
        if (this.debouncedSubmit) {
            $searchInput.off("input", this.debouncedSubmit);
            this.debouncedSubmit.cancel();
        }
    }

    displayResults(html) {
        const $dropdownList = $("#student-dropdown-list");
        const $dropdown = $("#student-dropdown");
        const $container = $("#student-search-bar-container");
        
        $dropdownList.html(html);
        $dropdown.removeClass("d-none");
        $container.addClass("dropdown-open");
    }

    displayError() {
        const $dropdownList = $("#student-dropdown-list");
        const $dropdown = $("#student-dropdown");
        const $container = $("#student-search-bar-container");
        
        $dropdownList.empty();
        $dropdownList.append('<li class="dropdown-item text-danger">Erreur lors de la recherche</li>');
        $dropdown.removeClass("d-none");
        $container.addClass("dropdown-open");
    }

    hideDropdown() {
        const $dropdown = $("#student-dropdown");
        const $container = $("#student-search-bar-container");
        const $dropdownList = $("#student-dropdown-list");

        $dropdown.addClass("d-none");
        $container.removeClass("dropdown-open");
        $dropdownList.empty();
    }
}